import requests from"./requests";export default{info:{key:"python",title:"Python",extname:".py",default:"python3"},requests:requests};
//# sourceMappingURL=index.js.map